module.exports = __webpack_public_path__ + "img/Simple Green.a64f53cc.jpg";